export default "__VITE_ASSET__EmuFzorU__"